import { Label, Paragraph, FormGroup } from './styles/common';
import { OptionList } from './SelectableOption.styles';

export function FormInputRadio({
  label, name, paragraph, options, registration, error, value, onChange, disabled,
}) {
  const rowLayout = options.length <= 3;

  // A radio group is "touched" (onTouched mode) only on blur, which clicking
  // an option never triggers — so a valid pick would leave the error text
  // showing until the field lost focus some other way. RHF's onChange/onBlur
  // are the same handler keyed on event.type; hand it a blur-typed synthetic
  // event right after the change so the invalid state clears at once.
  // (Mirrors FormInputSelect.) There's no separate "valid" styling: a radio
  // has no invalid-interim state to confirm out of — the checked option-card's
  // accent border already reads as answered.
  const handleRegistrationChange = (e) => {
    registration.onChange(e);
    registration.onBlur({
      type: 'blur',
      target: { name: registration.name, value: e.target.value },
    });
  };

  return (
    <FormGroup aria-invalid={error !== undefined ? 'true' : undefined}>
      {label !== undefined && <Label as="span">{label}</Label>}
      {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
      <OptionList
        role="radiogroup"
        aria-label={label}
        className={`${rowLayout ? 'row-layout' : ''} ${error !== undefined ? 'is-invalid' : ''}`}
      >
        {options.map((opt, index) => (
          <label
            key={index.toString()}
            className={`option-card shape-round ${disabled ? 'is-disabled' : ''}`}
          >
            {registration === undefined ? (
              <input
                type="radio"
                name={name}
                disabled={disabled}
                value={opt.value}
                checked={value == opt.value} // eslint-disable-line eqeqeq
                onChange={() => onChange(opt.value)}
              />
            ) : (
              <input
                type="radio"
                name={name}
                disabled={disabled}
                value={opt.value}
                {...registration}
                onChange={handleRegistrationChange}
              />
            )}
            <span className="option-indicator"><span className="dot" /></span>
            <span className="option-label">{opt.label}</span>
          </label>
        ))}
      </OptionList>
      {error !== undefined && (
        <div className="invalid-feedback d-block" role="alert">{error}</div>
      )}
    </FormGroup>
  );
}
